import { Box, Text, useThemeUI } from "theme-ui";
import { useRef } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Button, SvgOrImg } from "components";
import { CloseIcon } from "components/icons";
import ModalCenterEnlarged from "../ModalCenterEnlarged";
import * as styles from "./ModalSkateOrderGuidance.styles";

export default function ModalSkateOrderGuidance({
  isTopMostModal,
  onClose,
  equipmentImages,
}) {
  const {
    theme: { isMobile },
  } = useThemeUI();
  const sliderRef = useRef();

  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    arrows: false,
    adaptiveHeight: true,
    appendDots: (dots) => (
      <Box sx={styles.customDotsContainer}>
        <ul style={{ margin: "0px" }}>
          {dots.map((dot, index) => (
            <li
              key={index}
              className={index === dot.props["data-index"] ? "active" : ""}
            >
              {dot.props.children}
            </li>
          ))}
        </ul>
      </Box>
    ),
  };

  return (
    <>
      <ModalCenterEnlarged
        isTopMostModal={isTopMostModal}
        onClose={onClose}
        equipmentImages
        disableEscapeKey
        background={"#fff"}
        boxShadow={"none"}
        modalBottom={"50px"}
      >
        <Box>
          <Button
            variant="unstyled"
            sx={styles.closeButton({ isMobile })}
            onClick={onClose}
          >
            <CloseIcon strokeWidth="10" stroke="#fff" />
          </Button>
          <Slider {...settings} ref={sliderRef}>
            {equipmentImages.map((equipmentImage, index) => (
              <Box key={index}>
                <Box sx={styles.modalContainer}>
                  <Text sx={styles.title}>{equipmentImage.title}</Text>
                  <SvgOrImg
                    src={equipmentImage.url}
                    alt={equipmentImage.alt || ""}
                    sx={styles.displayImage}
                    draggable={false}
                  />
                  <Text sx={styles.step}>{equipmentImage.step}</Text>
                  <Text sx={styles.detail}>{equipmentImage.detail}</Text>
                  <Text sx={styles.description}>
                    {equipmentImage.description}
                  </Text>
                  <Box sx={styles.buttons}>
                    <Button sx={styles.skipButton} onClick={onClose}>
                      {equipmentImage.skipButton}
                    </Button>
                    {index < equipmentImages.length - 1 ? (
                      <Button
                        sx={styles.nextButton}
                        onClick={() => {
                          sliderRef.current.slickNext();
                        }}
                      >
                        {equipmentImage.nextButton}
                      </Button>
                    ) : (
                      <Button sx={styles.nextButton} onClick={onClose}>
                        {equipmentImage.nextButton}
                      </Button>
                    )}
                  </Box>
                </Box>
              </Box>
            ))}
          </Slider>
        </Box>
      </ModalCenterEnlarged>
    </>
  );
}
